import Route from '@ember/routing/route';

export type LinkLandingStatus = 'ok' | 'expired' | 'invalid';

const STATUSES: readonly LinkLandingStatus[] = ['ok', 'expired', 'invalid'];

/**
 * Public landing for the verify-later SMS link. tio-api has already redeemed the token
 * by the time the member arrives, so this only reads the outcome it was handed.
 */
export default class PhoneVerifiedRoute extends Route {
  queryParams = {
    status: { refreshModel: true },
  };

  /**
   * @param params.status tio-api's redeem outcome; anything else reads as `invalid`,
   *   the one state that reveals nothing about the token
   */
  model(params: { status?: string }): { status: LinkLandingStatus } {
    const status = STATUSES.find((known) => known === params.status) ?? 'invalid';

    return { status };
  }
}
